import React from 'react';
import {
  confirmable,
  createConfirmation,
} from 'react-confirm';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

const StrongPasswordDialog = ({
  show,
  dismiss,
  cancel,
}) => {
  const {
    t,
  } = useTranslation(undefined, { useSuspense: false });

  return (
    <Dialog
      open={show}
      onClose={dismiss}
      className="strong-password-dialog"
    >
      <DialogTitle>
        {t('Tips for a strong password')}
      </DialogTitle>
      <DialogContent>
        <p><b>Make it long -</b> This is the most critical factor. Your password must be 12 characters or more.</p>
        <p><b>Use a mix of characters -</b> Using upper-case, lower-case, numbers and symbols all make your password harder to crack.</p>
        <p><b>Avoid common substitutions -</b> Common substitutions such as substituting the letter O with a zero 0 and letter L with a 1 are actually likely to make your password easier to guess.</p>
        <h4>The best password methods</h4>
        <p><b>The multiple word phrase method -</b> Choose 3 or more random words. Use proper nouns, the names of local businesses, historical figures, any words you know in another language etc.</p>
        <p><b>The sentence method -</b> Think of a random sentence and transform it into a password using a rule. e.g. taking the first two letters of every word in a five word sentence.</p>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => { cancel() }}
          className="strong-password-dialog-close-button"
        >
          {t('Close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const confirm = createConfirmation(confirmable(StrongPasswordDialog));

export default function(content, options = {}) {
  return confirm({ content, options });
}
